export const GROUPED_BAR_TICK_MAX_LENGTH = 32
export const GROUPED_BAR_TICK_MAX_ROTATION = 45

/**
 * Truncate a Chart.js x-tick so long category labels cannot smear the axis.
 * Short labels are returned unchanged.
 */
export function formatGroupedBarTickLabel(
  label: unknown,
  maxLength: number = GROUPED_BAR_TICK_MAX_LENGTH,
): unknown {
  if (typeof label !== 'string') {
    return label
  }
  if (label.length <= maxLength) {
    return label
  }
  return `${label.slice(0, Math.max(0, maxLength - 1))}…`
}
